<template>
  <div id="app">
    <main id="content">
      <app-header />
      <transition name="fade" mode="out-in">
        <router-view />
      </transition>
    </main>
    <app-footer />
  </div>
</template>

<script>
import AppHeader from './components/AppHeader'
import AppFooter from './components/AppFooter'

export default {
  name: 'app',

  components: { AppFooter, AppHeader }
}
</script>

<style lang="sass">
@import url('https://fonts.googleapis.com/css?family=Baloo+Bhai&display=swap')

html, body
  height: 100%
  width: 100%
  background: #333
  padding: 0
  margin: 0
  color: #ddd

a
  color: #ff9900

  &:hover,&:focus,&:active
    text-decoration: none
    color: #ff9900
    text-decoration: underline dashed

p
  font-size: 1.5rem

h1, h2, h3, h4, h5, h6
  color: #fff

h3
  font-size: 2.5rem

h4
  font-size: 2rem

h5
  font-size: 1.5rem

strong
  font-weight: normal
  color: #fff
  text-decoration: underline dashed

hr
  border-top: 1px solid #555

#app
  font-family: 'Baloo Bhai', sans-serif
  display: flex
  flex-direction: column
  height: 100%

#content
  flex: 1 0 auto

.container
  padding-bottom: 3rem

.img-fluid
  max-height: 680px

// ROUTE TRANSITIONS
.fade-enter-active, .fade-leave-active
  transition-duration: 0.5s
  transition-property: opacity
  transition-timing-function: ease

.fade-enter, .fade-leave-active
  opacity: 0
</style>
